import cn from 'classnames'
import React, { Children, FC, useState } from 'react'
import Button from '../Button'
import s from './TabContent.module.scss'

type TabContentProps = {
    className: string
    tabHeadings: string[]
    preselectIndex?: number
    callback?: (title: string) => void
}

export const TabContent: FC<TabContentProps> = ({
    children,
    className,
    tabHeadings,
    preselectIndex = 0,
    callback
}) => {
    const childrenCount = Children.count(children)
    const lastTabIdx = childrenCount - 1
    const [selectedIdx, setSelectedIdx] = useState(
        preselectIndex > lastTabIdx ? lastTabIdx : preselectIndex
    )
    const handleClick = (id: number, title = '') => {
        setSelectedIdx(id)

        if (callback && typeof callback === 'function') {
            callback(title)
        }
    }

    if (childrenCount <= 1)
        throw new Error(
            'There should be more than 1 child component to use `TabContent`'
        )

    if (childrenCount !== tabHeadings.length)
        throw new Error(
            'There should be the same number of tab headings as children'
        )

    return (
        <div>
            <div className={cn(s['button-group'], className)}>
                {tabHeadings.map((heading, idx) => (
                    <Button
                        key={heading}
                        onClick={() => handleClick(idx, heading)}
                        className={cn(
                            idx === selectedIdx
                                ? s['enable-button']
                                : s['fade-button']
                        )}
                    >
                        {heading}
                    </Button>
                ))}
            </div>
            <div className={s['group-options']}>
                {Children.map(children, (child, idx) => (
                    <div className={idx !== selectedIdx ? 'hidden' : ''}>
                        {child}
                    </div>
                ))}
            </div>
        </div>
    )
}
